import { type PaginationMeta } from "@design-system/pagination";
import type { DataAttributes } from "@design-system/utils";
import type { ReactTable, RowData } from "@tanstack/react-table";
import { createContext } from "react";

import type { DataTableFeatures } from "./features";
import type { SortOrder } from "./schemas";

interface DataTableSearch<TSortBy = string> {
  sortBy?: TSortBy;
  sortOrder?: SortOrder;
  page: number;
  pageSize: number;
}

interface DataTableContextValue<TData extends RowData, TSortBy = string> {
  table: ReactTable<DataTableFeatures, TData>;
  search: DataTableSearch<TSortBy>;
  meta?: PaginationMeta;
  onRowClick?: (item: TData) => void;
  getRowAttributes?: (item: TData) => DataAttributes;
  /** Called when a data row gains focus (cell navigation), or null for headers. */
  onRowFocus?: (item: TData | null) => void;
  /** Called on Escape while focus is inside the grid (cell navigation). */
  onEscape?: () => void;
  handleSort: (sortBy: TSortBy) => void;
  handlePageChange: (pageIndex: number) => void;
  handlePageSizeChange: (pageSize: number) => void;
}

const DataTableContext = createContext<DataTableContextValue<
  RowData,
  unknown
> | null>(null);
export { DataTableContext };
export type { DataTableContextValue, DataTableSearch };
